// src/services/auth.service.ts
import {
  LoginRequest,
  RegisterRequest,
  AuthResponse,
  User,
} from "../types/auth";
import { MessageResponse } from "../types/response"; // Assuming you create this type too

// Assuming this is your base URL, keep it consistent
// const API_URL = "http://localhost:8080/api/auth/";
const API_URL = "https://task-management-backend-1g4v.onrender.com/api/auth/";

const register = async (
  userData: RegisterRequest
): Promise<MessageResponse> => {
  const response = await fetch(API_URL + "signup", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(userData),
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Registration failed");
  }
  return response.json();
};

const login = async (credentials: LoginRequest): Promise<User> => {
  const response = await fetch(API_URL + "signin", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    // IMPORTANT: Send the 'email' field in the request body, not 'username'
    body: JSON.stringify({ email: credentials.email, password: credentials.password }),
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Login failed");
  }
  const data: AuthResponse = await response.json();
  if (data.token) {
    // Store token and user info in local storage
    localStorage.setItem(
      "user",
      JSON.stringify({
        id: data.id,
        username: data.username,
        email: data.email,
        roles: data.roles,
        token: data.token,
      } as User & { token: string })
    ); // Combine User and token
  }
  // Return the user object (without the raw token for client-side use)
  return {
    id: data.id,
    username: data.username,
    email: data.email,
    roles: data.roles,
    token: data.token, // <-- Include the token here
  };
};

const logout = () => {
  localStorage.removeItem("user");
};

const getCurrentUser = (): User | null => {
  const userStr = localStorage.getItem("user");
  if (userStr) {
    const storedUser = JSON.parse(userStr);
    // Ensure it matches the User interface structure
    return {
      id: storedUser.id,
      username: storedUser.username,
      email: storedUser.email,
      roles: storedUser.roles,
      token: storedUser.token, // <-- Include the token here
    };
  }
  return null;
};

const AuthService = {
  register,
  login,
  logout,
  getCurrentUser,
};

export default AuthService;